const cognitoConfig = {
  Auth: {
    // Specific auth info
    // identityPoolId: 'xxx',
    region: process.env.VUE_APP_COGNITO_REGION,
    userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
  }
}

export default cognitoConfig;
